import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';

import { gridSpacing } from 'store/constant';

import SelectFilter from './SelectFilter';
import TextFilter from './TextFilter';
import { AdvFilterV2Context } from '../filterContext';

import { updateFilters } from 'actions/planner-filters';


const InternalTeamFilters = ({ bcRosterOnly, setBcRosterOnly, platform }) => {
  const dispatch = useDispatch();
  const v2 = useContext(AdvFilterV2Context);

  return (
    <Grid container spacing={gridSpacing} sx={{height: 300, overflowY: 'scroll'}}>
      <Grid item xs={12}>
       <Box className={v2 ? 'dv2-group-box' : undefined}>
        {v2 && <Typography className="dv2-group-label">Internal Team</Typography>}
        {/* YCP Roster Only Toggle */}
        {platform === 'youtube' && (
          <Grid container spacing={2} alignItems="center" justifyContent="space-evenly" sx={{ mb: 2 }}>
            <Grid item xs={3}>
              <Typography variant="h6" gutterBottom>
                YCP Roster Only
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <span style={{ padding: '2px 8px', background: '#dc2626', color: '#fff', fontSize: 11, fontWeight: 700, borderRadius: 4 }}>YCP</span>
                </Grid>
                <Grid item>
                  <Switch
                    checked={bcRosterOnly === 'yes'}
                    onChange={(e) => {
                      const value = e.target.checked ? 'yes' : 'no';
                      setBcRosterOnly(value);
                      dispatch(updateFilters('bcRosterOnly', value, true));
                    }}
                    size="small"
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': { color: '#dc2626' },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#dc2626',
                      },
                    }}
                  />
                </Grid>
                <Grid item>
                  <Typography variant="caption" color="text.secondary">
                    Show only YCP Roster creators with verified YouTube data
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}

        <TextFilter title={'Influencer Final Price'} payloadKey='influencerFinalPrice'  />
        <TextFilter title={'Brand Final Price'} payloadKey='brandFinalPrice'/>
        <SelectFilter title='Email' payloadKey={'isEmail'}
          selectOptions={[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]}
        />
        <SelectFilter title='Phone' payloadKey={'isPhone'}
          selectOptions={[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]}
        />
        <SelectFilter title='Audience Data Available' payloadKey={'isAudienceData'}
          selectOptions={[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]}
        />
       </Box>
      </Grid>
    </Grid>
  )
}

export default InternalTeamFilters;